const category = {
  teacher: {
    SIS: 'sis',
    ASSIGNMENT: 'assignment',
    PRINT: 'print',
    EMAIL: 'email',
    LOGIN: 'login',
    DEFAULT: 'default',
    ACTIVITIES: 'activities',
    REPORTS: 'reports',
    BENCHMARK: 'benchmark',
    TRACKING: 'tracking',
    PROGRESSMONITORING: 'progress',
    DIAGNOSTIC: 'diagnostic',
    DYSLEXIA: 'dyslexia',
    DYSLEXIARISK: 'dyslexiarisk',
    PARENT: 'parent',
    ADMIN: 'admin',
    GRADEBOOK: 'gradebook',
    AIT: 'ait',
  },
  student: {
    DEFAULT: 'default',
    STUDENTHOME: 'studenthome',
    AUDIOCONTROLS: 'audiocontrols',
    REPORTS: 'reports',
    INTERVENTION: 'intervention',
    ASSESSMENT: 'assessment',
    TUTOR: 'tutor',
    HELP: 'help',
    LOGIN: 'login',
    REPORT: 'report',
    RECOMMENDATION: 'recommendation',
  },
};

export { 
  category as default,
  category,
};
export const routesCategory = category;
export const categoryTeacher = category['teacher'];
export const categoryStudent = category['student'];